import React from 'react';
import About from '../About/About';
import BlogInfo from '../Blog/BlogInfo/BlogInfo';
import ContactForm from '../Contact/ContactForm/ContactForm';
import ContactInfo from '../Contact/ContactInfo/ContactInfo';
import Navbar from '../Navbar/Navbar';
import ProjectCard from '../Project/ProjectCard/ProjectCard';
import ProjectInfo from '../Project/ProjectInfo/ProjectInfo';
import './HomePage.css';

const HomePage = () => {


    return (
        <div>
            <Navbar />
            <About />
            <ProjectInfo />
            <BlogInfo />
            <ContactInfo />
            <ContactForm />
        </div>
    );
};

export default HomePage;